import { FaStar, FaRegStar } from "react-icons/fa";
import "./TestimonialCard.css";

export default function TestimonialCard({ testimonial }) {
  return (
    <div className="testimonial-card">
      <div className="testimonial-card__stars" aria-label={`${testimonial.rating} out of 5 stars`}>
        {Array.from({ length: 5 }).map((_, i) =>
          i < testimonial.rating ? <FaStar key={i} aria-hidden="true" /> : <FaRegStar key={i} aria-hidden="true" />
        )}
      </div>
      <p className="testimonial-card__review">&ldquo;{testimonial.review}&rdquo;</p>
      <div className="testimonial-card__author">
        <div className="testimonial-card__avatar" aria-hidden="true">{testimonial.name.charAt(0)}</div>
        <span>{testimonial.name}</span>
      </div>
    </div>
  );
}
